import React from 'react';
import {connect} from 'react-redux';

import PublishBreakModal from "components/break/BreakPublish/PublishBreakModal";
import {hideValidateChallengeStatusModalAction} from "./actions";

const mapStateToProps = (state) => {
    return {
        intlPrefix: 'validate',
        isModalOpen: state.publishChallenge.showValidateChallengeStatusModal,
        validationErrors: state.publishChallenge.validationErrors,
        successful: state.publishChallenge.successful
    }
};

const mapDispatchToProps = (dispatch) => ({
    handleClose: () => dispatch(hideValidateChallengeStatusModalAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishBreakModal);



// WEBPACK FOOTER //
// ./public/pages/BreakPublish/ValidateBreakModalContainer.jsx